<h3 mat-dialog-title>Destinatarios del monitor #{{ data.monitor.id }}</h3>

<mat-dialog-content class="dialog-content">
  <p class="dialog-description">Usuarios y conversaciones que reciben avisos cuando este monitor confirma una caída o una recuperación.</p>

  @if (default_notifiables.length > 0) {
    <div class="defaults-block">
      <mat-label>Se notifican siempre</mat-label>
      <ul class="defaults-list">
        @for (item of default_notifiables; track item.kind + '-' + item.id) {
          <li>
            <mat-icon aria-hidden="true">{{ item.kind === 'user' ? 'person' : 'forum' }}</mat-icon>
            <span class="defaults-name">{{ item.label }}</span>
            <span class="defaults-reason-chip">{{ item.reason_label }}</span>
          </li>
        }
      </ul>
    </div>
  }

  <mat-label>Usuarios adicionales (Mail)</mat-label>
  <mat-form-field class="full-width nobottom" appearance="outline">
    <mat-chip-grid #users_chip_grid>
      @for (user of selected_users(); track user.id; let index = $index) {
        <mat-chip-row (removed)="removeUser(index)">
          {{ formatUserLabel(user) }}
          <button matChipRemove type="button">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      placeholder="Buscar usuarios…"
      [formControl]="users_search_ctrl"
      [matChipInputFor]="users_chip_grid"
      [matAutocomplete]="users_autocomplete"
    />
    <mat-autocomplete #users_autocomplete="matAutocomplete" (optionSelected)="addUser($event.option.value)">
      @for (user of filtered_users(); track user.id) {
        <mat-option [value]="user">
          <span class="option-row">
            <span class="option-name">{{ user.full_name }}</span>
            <span
              class="option-chip"
              [class.option-chip--bisual]="user.type === 'bisual'"
              [class.option-chip--cliente]="user.type === 'cliente'"
              [class.option-chip--partner]="user.type === 'partner'"
              >{{ user.type_label }}</span
            >
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-label>Mensajería instantánea adicional</mat-label>
  <mat-form-field class="full-width nobottom" appearance="outline">
    <mat-chip-grid #conversations_chip_grid>
      @for (conversation of selected_conversations(); track conversation.id; let index = $index) {
        <mat-chip-row (removed)="removeConversation(index)">
          {{ conversation.display_name }}
          <button matChipRemove type="button">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      placeholder="Buscar conversaciones…"
      [formControl]="conversations_search_ctrl"
      [matChipInputFor]="conversations_chip_grid"
      [matAutocomplete]="conversations_autocomplete"
    />
    <mat-autocomplete #conversations_autocomplete="matAutocomplete" (optionSelected)="addConversation($event.option.value)">
      @for (conversation of filtered_conversations(); track conversation.id) {
        <mat-option [value]="conversation">
          <span class="option-row">
            <span class="option-name">{{ conversation.display_name }}</span>
            <span
              class="option-chip"
              [class.option-chip--slack]="conversation.provider === 'slack'"
              [class.option-chip--google-chat]="conversation.provider === 'google_chat'"
              [class.option-chip--teams]="conversation.provider === 'teams'"
              >{{ conversation.provider_label }}</span
            >
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="saving()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving()">
    @if (saving()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Guardar
    }
  </button>
</mat-dialog-actions>
